import { AgGridReact } from "ag-grid-react";
import {
  forwardRef,
  memo,
  useCallback,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import AsyncSelect from "react-select/async";

import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { SyncUtils } from "../../utils/SyncUtils";
import Select from "react-select";
import AgProductSearchEditor from "./AgProductSearchEditor";
import AgProductRenderor from "./AgProductRenderor";
import { AgentUtils } from "../../utils/AgentUtils";

export default function TSaleList(props) {
  const [rowData] = useState(getRows(999));

  const [gridApi, setGridApi] = useState();
  const gridRef = useRef();

  const { t } = useTranslation();
  const translate = t;

  useEffect(() => {
    if (gridRef.current.api) {
    } else {
    }
    if (props.saleData.length > 0) {
      updateAgGrid(gridRef.current.api);
    } else {
      clearGrid();
    }
  }, [props.saleData, gridRef.current]);

  useEffect(() => {}, [props.saleData]);

  var biRef = {};

  props.biRef.saleListAg = {
    parentEvent: parentEvent,
  };

  function parentEvent(event, value1, value2, value3) {
    if (event === "getCurrentRow") {
      if (gridRef.current && gridRef.current.api) {
        return gridRef.current.api.getSelectedNodes();
      }
    }
  }

  function clearGrid() {
    if (gridRef.current && gridRef.current.api) {
      gridRef.current.api.setRowData(getRows(999));
    }
  }

  async function updateAgGrid(api) {
    const agGridData = [];

    if (gridRef.current && gridRef.current.api) {
      gridRef.current.api.forEachNodeAfterFilterAndSort(function (
        rowNode,
        index
      ) {
        const data = rowNode.data;
        agGridData.push(data);
      });
      let itemsToUpdate = [];
      let i = 0;
      for (let d of props.saleData) {
        if (!isMatching(d, agGridData[i])) {
          itemsToUpdate.push(getAgGridData(d, agGridData[i]));
        }
        i++;
      }
      for (let j = i; j < 999; j++) {
        let exists = isDataFound(agGridData, j);
        if (exists) {
          itemsToUpdate.push(getBlankData(agGridData[j]));
        }
      }
      //Reconcile
      if (itemsToUpdate.length > 0) {
        const res = gridRef.current.api.applyTransaction({
          update: itemsToUpdate,
        });
      }
      //
    }
  }

  function getTableBodyHeight() {
    if (props.context.appMode === "desktop-pos") {
      return (
        (
          AgentUtils.getWindowDimensionsExAppBarsDualMode(props.context.appMode)
            .h - (props.saleType === "SERVICE" ? 240 : 200)
        ).toString() + "px"
      );
    } else {
      return (
        (
          AgentUtils.getWindowDimensionsExAppBarsDualMode(props.context.appMode)
            .h - (props.saleType === "SERVICE" ? 260 : 160)
        ).toString() + "px"
      );
    }
  }

  function isDataFound(agGridData, i) {
    if (agGridData[i].product) {
      return true;
    }
    if (agGridData[i].unitType) {
      return true;
    }
    if (agGridData[i].price) {
      return true;
    }
    if (agGridData[i].discountPer) {
      return true;
    }
    if (agGridData[i].discountAmt) {
      return true;
    }
    if (agGridData[i].tax) {
      return true;
    }
    if (agGridData[i].amount) {
      return true;
    }
    return false;
  }

  function isMatching(saleData, agRow) {
    return false;
  }

  function getBlankData(agRow) {
    agRow["product"] = null;
    agRow["unitType"] = null;
    agRow["qty"] = null;
    agRow["price"] = null;
    agRow["discountPer"] = null;
    agRow["discountAmt"] = null;
    agRow["tax"] = null;
    agRow["amount"] = null;
  }
  function getAgGridData(d, agRow) {
    agRow["product"] = {
      prodBean: d[9].info.productBean,
      pricingBean: d[9].info.pricingBean,
    };
    agRow["unitType"] = d[4].v;
    agRow["qty"] = d[5].v;
    agRow["price"] = d[3].v;
    agRow["discountPer"] = d[6].v;
    agRow["discountAmt"] = d[9].info.discountAmount;
    agRow["tax"] = d[7].v;
    agRow["amount"] = d[8].v;

    return agRow;
  }

  function getRows(count) {
    let arr = [];
    for (let i = 0; i < count; i++) {
      arr.push({ id: i + 1 });
    }
    return arr;
  }

  function onProductSelected(prodBean, pricingBean, rowId) {
    props.onAddProduct(prodBean, pricingBean, rowId);
  }

  const defaultColDef = useMemo(() => {
    return {
      cellStyle: {
        fontSize: "18px",
        paddingLeft: "7px",
        paddingRight: "7px",
      },
      headerStyle: {
        fontSize: "18px",
        paddingLeft: "7px",
        paddingRight: "7px",
      },
    };
  }, []);

  const columnDefs = [
    {
      headerName: "SN",
      field: "id",
      editable: false,
      width: 60,
    },
    {
      headerName: "Item",
      field: "product",
      cellEditor: AgProductSearchEditor,
      cellRenderer: AgProductRenderor,
      cellEditorPopup: true,
      cellEditorParams: {
        productCache: props.productCache,
        onProductSelected: onProductSelected,
        saleData: props.saleData,
        productType: props.productType,
        context: props.context,
      },
      //cellEditorPopup: true,
      editable: true,
      width: 400,
      suppressKeyboardEvent: function suppressKey(params) {
        let KEY_ENTER = 13;
        let KEY_LEFT = 37;
        let KEY_UP = 38;
        let KEY_RIGHT = 39;
        let KEY_DOWN = 40;
        var event = params.event;
        var key = event.which;
        var editingKeys = [KEY_LEFT, KEY_RIGHT, KEY_UP, KEY_DOWN, KEY_ENTER];
        var suppress = params.editing && editingKeys.indexOf(key) >= 0;
        return suppress;
      },
    },
    {
      headerName: "UOM",
      field: "unitType",
      //cellEditorPopup: true,
      editable: false,
      width: 80,
    },
    {
      headerName: "Quantity",
      field: "qty",
      //cellEditorPopup: true,
      editable: true,
      flex: 1,
      type: "rightAligned",
    },
    {
      headerName: "Price",
      field: "price",
      //cellEditorPopup: true,
      editable: true,
      flex: 1,
      type: "rightAligned",
    },
    {
      headerName: "Disc",
      field: "discountAmt",
      //cellEditorPopup: true,
      editable: true,
      flex: 1,
      type: "rightAligned",
    },
    {
      headerName: "Disc %",
      field: "discountPer",
      //cellEditorPopup: true,
      editable: true,
      width: 120,
      type: "rightAligned",
    },
    {
      headerName: "Tax",
      field: "tax",
      flex: 1,
      type: "rightAligned",
      //cellEditorPopup: true,
    },
    {
      headerName: "Amount",
      field: "amount",
      flex: 1,
      //cellEditorPopup: true,
      type: "rightAligned",
    },
  ];

  const onCellValueChanged = (event) => {
    if (event.column.colId === "qty") {
      props.onChangeValueEvent(event.value, "updateQty", event.rowIndex);
    } else if (event.column.colId === "price") {
      props.onChangeValueEvent(event.value, "updatePrice", event.rowIndex);
    } else if (event.column.colId === "product") {
      handleProuctNameChangeEvent(event);
    } else if (event.column.colId === "discountAmt") {
      props.onChangeValueEvent(
        event.value,
        "updateDiscountAmount",
        event.rowIndex
      );
    } else if (event.column.colId === "discountPer") {
      props.onChangeValueEvent(
        event.value,
        "updateDiscountPer",
        event.rowIndex
      );
    }
  };

  function handleProuctNameChangeEvent(event) {
    let d = props.saleData[event.rowIndex];
    if (d) {
      if (d[9].info.productBean.id != event.value.prodBean.id) {
        let dd = event.data;
        dd.product = {
          prodBean: d[9].info.productBean,
          pricingBean: d[9].info.pricingBean,
        };
        let itemsToUpdate = [];
        itemsToUpdate.push(dd);
        const res = gridRef.current.api.applyTransaction({
          update: itemsToUpdate,
        });
      }
    }
  }

  const onGridReady = (e) => {
    setGridApi(e.api);
  };

  function onCellKeyDown(e) {
    console.log(e);
    var backspaceEvnt = new KeyboardEvent("keypress", e.event);
    if (e.event.keyCode != 13) document.dispatchEvent(backspaceEvnt);
  }

  return (
    <div
      className="ag-theme-alpine"
      style={{ height: getTableBodyHeight(), width: "100%" }}
    >
      <AgGridReact
        onGridReady={onGridReady} // register event listener
        ref={gridRef}
        rowData={rowData}
        columnDefs={columnDefs}
        onCellValueChanged={onCellValueChanged}
        rowSelection="single"
        defaultColDef={defaultColDef}
        onCellKeyDown={onCellKeyDown}
      ></AgGridReact>
    </div>
  );
}
